import { Label } from '@r1-frontend/ui-react/components/label';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import { ddmmmmyyyy } from '~/src/helpers/date';
import { clearHTMLTags, clearNbsp } from '~/src/helpers/string';

import * as ST from './styled';

const TEXT_LENGTH = 197;

export const CardNews = ({ item, isFirstItem, forSlider }) => {
    const { alias, title, text, image, active_from, tags, host } = item;
    // TODO: Fix later in https://ticket.ertelecom.ru/browse/WEB-43177
    const shortText = clearNbsp(clearHTMLTags(text))
        .substr(0, TEXT_LENGTH) + '...';
    const imageURL = host + image;
    const newsDate = ddmmmmyyyy(new Date(active_from));
    const firstTag = isEmpty(tags) ? '' : get(tags[0], 'title', '');

    const PictureWrap = forSlider ? ST.PictureWrap : ST.CardPictureWrap;

    return (
        <ST.CardNews isFirstItem={isFirstItem}>
            <PictureWrap isFirstItem={isFirstItem} forSlider={forSlider}>
                <ST.CardPicture src={imageURL} forSlider={forSlider} alt={title}/>
                <ST.CardPictureTag>
                    <Label bgColor={COLORS.LabelsBg_5} textColor={COLORS.LabelsText_5}>{firstTag}</Label>
                </ST.CardPictureTag>
            </PictureWrap>

            <ST.CardDescription>
                <ST.CardDate>
                    {newsDate || ''}
                </ST.CardDate>
                <Link href={'/news/[alias]'} as={`/news/${alias}`} scroll={false} passHref>
                    <ST.CardTitle isFirstItem={isFirstItem}>
                        {title}
                    </ST.CardTitle>
                </Link>
                {!forSlider &&
                    <ST.CardText isFirstItem={isFirstItem}>
                        {shortText}
                    </ST.CardText>
                }
            </ST.CardDescription>
        </ST.CardNews>
    );
};

CardNews.propTypes = {
    item: PropTypes.object.isRequired,
    isFirstItem: PropTypes.bool,
    forSlider: PropTypes.bool,
};

CardNews.defaultProps = {
    isFirstItem: false,
    forSlider: false,
};
